// Challenge markers for the world map, drawn on the pixel grid like the
// decorations on a Minecraft map item. Each state has its own shape so it
// doesn't rely on colour alone: a flag (two frames, it waves), a flag with
// a tick, a padlock and a block with the missing texture.

/* eslint-disable array-element-newline */

const FLAG = [
    [
        '.KK.........',
        'KwwKKKKKKKK.',
        'KwwKHHHHHHHK',
        'KwwKFFFFFFK.',
        'KwwKFFFFFK..',
        'KwwKFFFFFFK.',
        'KwwKSSSSSSSK',
        'KwwKKKKKKKK.',
        'KwwK........',
        'KwwK........',
        'KwwK........',
        'KwwK........',
        'KKKKK.......',
    ],
    [
        '.KK.........',
        'KwwKKKKKKK..',
        'KwwKHHHHHHK.',
        'KwwKFFFFFFFK',
        'KwwKFFFFFK..',
        'KwwKFFFFFFFK',
        'KwwKSSSSSSK.',
        'KwwKKKKKKK..',
        'KwwK........',
        'KwwK........',
        'KwwK........',
        'KwwK........',
        'KKKKK.......',
    ],
]

const SOLVED = [
    '.KK.........',
    'KwwKKKKKKKK.',
    'KwwKHHHHHCHK',
    'KwwKFFFFCFK.',
    'KwwKCFFCFK..',
    'KwwKFCCFFFK.',
    'KwwKSSSSSSSK',
    'KwwKKKKKKKK.',
    'KwwK........',
    'KwwK........',
    'KwwK........',
    'KwwK........',
    'KKKKK.......',
]

const LOCK = [
    '..KKKKKK..',
    '.KwwwwwwK.',
    '.KwKKKKwK.',
    '.KwK..KwK.',
    '.KwK..KwK.',
    'KKKKKKKKKK',
    'KHHHHHHHHK',
    'KFFFKKFFFK',
    'KFFFKKFFFK',
    'KFFFFFFFFK',
    'KSSSSSSSSK',
    'KKKKKKKKKK',
]

// Minecraft's missing texture: magenta and black, two pixels a square.
const MISSING = Array.from({ length: 10 }, (_, y) => Array.from({ length: 10 }, (_, x) => {
    if (x === 0 || y === 0 || x === 9 || y === 9) return 'K'
    return (((x - 1) >> 1) + ((y - 1) >> 1)) & 1 ? 'B' : 'M'
}).join(''))

const PALETTES = {
    open: { K: '#0b0612', w: '#d9cfc1', F: '#53d8df', H: '#a7f3f6', S: '#2a8f99' },
    solved: { K: '#0b0612', w: '#d9cfc1', F: '#75da91', H: '#bdf5cb', S: '#3d8f55', C: '#ffffff' },
    locked: { K: '#0b0612', w: '#a39cb5', F: '#7b7390', H: '#a39cb5', S: '#4e4760' },
    unreleased: { K: '#0b0612', M: '#f800f8', B: '#000000' },
}

// One SVG path per colour, a unit square per pixel.
function compile (rows, palette) {
    const paths = {}
    rows.forEach((row, y) => {
        [...row].forEach((ch, x) => {
            if (!palette[ch]) return
            paths[ch] = (paths[ch] || '') + `M${x} ${y}h1v1h-1z`
        })
    })
    return {
        w: rows[0].length,
        h: rows.length,
        layers: Object.keys(paths).map(ch => ({ fill: palette[ch], d: paths[ch] })),
    }
}

// Frames for every marker state.
export const SPRITES = {
    open: FLAG.map(f => compile(f, PALETTES.open)),
    solved: [compile(SOLVED, PALETTES.solved)],
    locked: [compile(LOCK, PALETTES.locked)],
    unreleased: [compile(MISSING, PALETTES.unreleased)],
}
